import axios from "axios";

const MEETING_EVENT_API_URL = `${process.env.REACT_APP_API_URL}/meeting`; 

const customHeaders = {
  'Content-Type': 'application/json',
};

// Fetch all meeting events
export const fetchMeetingEvents = async () => {
  const response = await axios.get(`${MEETING_EVENT_API_URL}`, { headers: customHeaders });
  return response.data;
};

// Create a new meeting event
export const addMeetingEvent = async (newMeetingEvent: { title: string; description: string; date: string; time: string; is_active: boolean; location?: string }) => {
  const response = await axios.post(MEETING_EVENT_API_URL, newMeetingEvent, { 
    headers: customHeaders
  });
  return response.data;
};

// Edit an existing meeting event
export const updateMeetingEvent = async (updatedMeetingEvent: { id: string; title: string; description: string; date: string; time: string; is_active: boolean; location?: string }) => {
  const response = await axios.put(`${MEETING_EVENT_API_URL}`, updatedMeetingEvent, { 
    headers: customHeaders
  });
  return response.data;
};
